import { lazy } from 'react'

export const publicRoutes = {
  auth: [
    {
      path: 'login',
      component: lazy(() => import('views/auth-views/login')),
      meta: { otherSignIn: false },
    },
    {
      path: 'register',
      component: lazy(() => import('views/auth-views/register')),
    },
    {
      path: 'forgot-password',
      component: lazy(() => import('views/auth-views/forgot-password')),
    },
    {
      path: 'forgot-password/reset',
      component: lazy(() => import('views/auth-views/reset-password')),
    },
  ],
}

export const protectedRoutes = {
  app: [
    {
      component: lazy(() => import('views/app-views/home')),
    },
  ],
  settings: [
    {
      component: lazy(() => import('views/app-views/settings/EditProfile')),
    },
    {
      path: 'change-password',
      component: lazy(() => import('views/app-views/settings/ChangePassword')),
    },
    {
      path: 'ssh-keys',
      component: lazy(() => import('views/app-views/settings/ssh/SshKeys')),
    },
    {
      path: 'rewards',
      component: lazy(() => import('views/app-views/settings/Rewards')),
    },
    {
      path: 'other',
      component: lazy(() => import('views/app-views/settings/Other')),
    },
  ],
  cards: [
    {
      path: 'new',
      component: lazy(() => import('views/app-views/cards/add-card')),
    },
  ],
  vps: [
    {
      component: lazy(() => import('views/app-views/vps')),
    },
    {
      path: 'new',
      component: lazy(() => import('views/app-views/vps/add-vps')),
    },
    {
      path: ':id',
      component: lazy(() => import('views/app-views/vps/vps-details')),
    },
    {
      path: ':id/term',
      component: lazy(() => import('views/app-views/vps/term')),
    },
    {
      path: ':id/vnc',
      component: lazy(() => import('views/app-views/vps/vnc')),
    },
    {
      path: ':id/resize',
      component: lazy(() => import('views/app-views/vps/resize')),
    },
  ],
  support: [
    {
      component: lazy(() => import('views/app-views/ticket')),
    },
    {
      path: 'new',
      component: lazy(() => import('views/app-views/ticket/add-ticket')),
    },
    {
      path: ':id',
      component: lazy(() => import('views/app-views/ticket/ticket-details')),
    },
  ],
  wallet: [
    {
      component: lazy(() => import('views/app-views/wallet')),
    },
    {
      path: 'order',
      component: lazy(() => import('views/app-views/wallet/step')),
    },
    {
      path: 'order/:id/method',
      component: lazy(() => import('views/app-views/wallet/step')),
    },
    {
      path: 'order/:id/checkout',
      component: lazy(() => import('views/app-views/wallet/step')),
    },
  ],
  checkout: [
    {
      component: lazy(() => import('views/app-views/checkout')),
    },
    {
      path: ':id',
      component: lazy(() => import('views/app-views/checkout')),
    },
  ],
  billing: [
    {
      path: 'checkout/:id/success',
      component: lazy(() => import('views/app-views/checkout/success')),
    },
    {
      path: 'checkout/:id/fail',
      component: lazy(() => import('views/app-views/checkout/fail')),
    },
  ],
  reverseProxy: [
    {
      component: lazy(() => import('views/app-views/reverse-proxy')),
    },
    {
      path: 'new',
      component: lazy(() => import('views/app-views/reverse-proxy/management')),
    },
    {
      path: ':id/configuration',
      component: lazy(() => import('views/app-views/reverse-proxy/management')),
    },
    {
      path: ':id/service',
      component: lazy(() => import('views/app-views/reverse-proxy/management')),
    },
    {
      path: ':id/summary',
      component: lazy(() => import('views/app-views/reverse-proxy/management')),
    },
  ],
  domain: [
    {
      component: lazy(() => import('views/app-views/domain')),
    },
    {
      path: ':id/dns',
      component: lazy(() => import('views/app-views/domain/domain-details')),
    },
    {
      path: ':id/email',
      component: lazy(() => import('views/app-views/domain/domain-details')),
    },
  ],
  email: [
    {
      component: lazy(() => import('views/app-views/email')),
    },
    {
      path: 'new',
      component: lazy(() => import('views/app-views/email/add-email')),
    },
    {
      path: ':id/edit',
      component: lazy(() => import('views/app-views/email/edit-email')),
    },
  ],
  automation: [
    {
      component: lazy(() => import('views/app-views/automation')),
    },
    {
      path: 'new',
      component: lazy(() => import('views/app-views/automation/add')),
    },
    {
      path: 'new/:automationId',
      component: lazy(() => import('views/app-views/automation/configure')),
    },
    {
      path: 'credentials',
      component: lazy(() => import('views/app-views/automation/credentials')),
    },
  ],
}
